import React, { useEffect, useState } from "react";
import { Stack, Box, Grid } from "@mui/material";
import "./emailTemplate.scss";
import copyImage from "../../Images/blueClone.png";
import infoImage from "../../Images/blue_info.svg";
import deleteIcon from "../../Images/delete_red_icon.svg";
import editIcon from "../../Images/Icon material-edit.svg";
import { useNavigate } from "react-router-dom";
import { API, MONTH_NAMES, APP_ROUTES, FOMRS } from "../../globals/constants/index";
import Cookies from "universal-cookie";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import api_call from "../../globals/common_utilities/axios_old";
import SingleDelete from "../SingleDeleteAlert/SingleDelete";
import { ToastContainer, toast } from "react-toastify";
import moment from "moment";

const EmailList = (props) => {
  const { res, getEmailTemplateList } = props;
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [emailTemplateId, setEmailTemplateId] = useState("");
  const onEmailEdit = async () => {
    navigate(APP_ROUTES.ROUTE_EMAILTEMPLATE, { state: {} });
  };
  const cookies = new Cookies();
  const loginData = cookies.get("loginData");
  const deleteEmail = (e, id) => {
    setDeleteModal(true);
    // EmailDelete(e, id);
    setEmailTemplateId(id);
  };
  const add3Dots = (string, limit) => {
    let dots = "...";
    if (string.length > limit) {
      string = string.substring(0, limit) + dots;
    }
    return string;
  };
  const EmailDelete = async (e, id) => {
    let queryParam = {
      id: emailTemplateId ? emailTemplateId : "",
      unique_id:
        loginData.role_code === "STUDIO_ADMIN"
          ? loginData.studio_id
          : loginData.id,
    };
    const response = await api_call(
      // token,
      "DELETE",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
        API.END_POINTS.EMAIL_TEMPLATE_DELETE,
      queryParam,
      {},
      {}
    )
      .then((response) => {
        toast.success("Records Deleted", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        closemodal();
        getEmailTemplateList();
      })
      .catch(() => {});
  };
  const closemodal = () => {
    setDeleteModal(false);
    setEmailTemplateId("");
  };
  useEffect(() => {}, [res]);
  return (
    <div id="emialList">
      {res.length > 0 ? (
        res?.map((res) => {
          return (
            <Box sx={{ bgcolor: "#0C0D16", m: "1% 1% 0.5% 1%" }}>
              {console.log("check the email response---", res)}
              <Stack
                direction={{ xs: "column", md: "row" }}
                sx={{
                  pt: "0.2%",
                  // flexDirection: { xs: 'column', sm: 'row' }
                }}
                onClick={() => {}}
                width="100%"
              >
                <Grid width={{ xs: "100%", sm: "100%", md: "90%" }}>
                  <Stack width="100%">
                    <Stack
                      direction="row"
                      spacing="2%"
                      justifyContent={{
                        xs: "space-around",
                        md: "flex-start",
                      }}
                    >
                      <Stack width="20%" className="fs-3" p="1%" pl="3%">
                        {add3Dots(res?.template_name, 15)}
                      </Stack>
                      <Stack
                        className="borderRight"
                        sx={{
                          borderRight: "1px solid #338fee",
                          height: "25px",
                          pt: "1%",
                        }}
                      ></Stack>
                      <Stack width="15%" className="fs-4" p="1%">
                        {moment(res?.created_at).format("Do MMMM YYYY")}
                      </Stack>
                      <Stack
                        className="borderRight"
                        sx={{
                          borderRight: "1px solid #338fee",
                          height: "25px",
                          pt: "1%",
                        }}
                      ></Stack>
                      <Stack
                        width="45%"
                        className="fs-4"
                        p="1%"
                        direction={{ sx: "coloumn", md: "row" }}
                      >
                        Created by :
                        <Stack mt="-0.5%" className="fs-3">
                          {add3Dots(res?.user?.name, 15)}
                        </Stack>
                      </Stack>
                    </Stack>
                    <Stack
                      sx={{
                        // mt: '0.6%',
                        width: "95%",
                        marginLeft: "2.5%",
                      }}
                    ></Stack>
                    <Stack direction="row">
                      <Stack width="100%">
                        <Stack
                          direction="row"
                          spacing="2%"
                          justifyContent="center"
                        >
                          {/* <Stack
														width="50%"
														className="fs-4"
														textAlign={'center'}
														p="1.2%"
														direction={{ sx: 'coloumn', md: 'row' }}
														justifyContent="center"
													>
														Training Name :
														<Stack mt="-0.5%" className="fs-3">
															Training Name 1
														</Stack>
													</Stack>
													<Stack
														className="borderRight"
														sx={{
															borderRight: '1px solid #338fee',
															height: '40px',
														}}
													></Stack> */}
                          {/* <Stack
                            width="50%"
                            className="fs-4"
                            p="1.2%"
                            textAlign={"center"}
                            direction="row"
                            justifyContent="center"
                          >
                            Template Language :
                            <Stack className="fs-3" mt="-0.5%">
                              {res?.language}
                            </Stack>
                          </Stack> */}
                        </Stack>
                      </Stack>
                    </Stack>
                  </Stack>
                </Grid>
                
                  <Grid width={{ xs: "100%", sm: "100%", md: "10%" }}>
                    <Box
                      sx={{
                        width: { xs: "98%", md: "94%" },
                        height: "90%",
                        background: "var(--subBoxBG)",
                        borderRadius: 1.5,
                        marginLeft: { xs: "0.8%", md: "0%" },
                        marginTop: { xs: "0%", md: "4%" },
                        marginBottom: { xs: "2%", md: "0%" },
                      }}
                    >
                      <Stack
                        direction={{ xs: "row", sm: "row", md: "column" }}
                        spacing={"5px"}
                        justifyContent={{
                          xs: "space-around",
                          md: "flex-start",
                        }}
                        sx={{
                          paddingBottom: "10%",
                        }}
                      >
                        <Stack
                          direction="row"
                          sx={{
                            justifyContent: "center",
                            p: { xs: "2%", md: "5%" },
                          }}
                        >
                          <span className="fs-4">Action</span>
                        </Stack>
                        <Stack
                          direction="row"
                          spacing={{ xs: "50%", md: 1 }}
                          sx={{
                            justifyContent: {
                              xs: "space-evenly",
                              md: "center",
                            },
                            paddingLeft: { xs: "10%", md: "0%" },
                            paddingTop: { xs: "2%", md: "0%" },
                          }}
                        >
                          {res?.created_by === loginData?.id ? (<Stack>
                            <Stack
                              spacing={1}
                              sx={{
                                width: { xs: 12, md: 16 },
                                height: { xs: 12, md: 16 },
                                mt: "4px",
                                cursor: "pointer",
                              }}
                            >
                              <img
                                src={editIcon}
                                alt=""
                                onClick={(e) => {
                                  navigate(APP_ROUTES.ROUTE_EMAILTEMPLATE, {
                                    state: {
                                      id: res?.id,
                                      action: "edit",
                                    },
                                  });
                                }}
                              />
                            </Stack>
                          </Stack>) : ("")}
                          <Stack>
                          <Stack
                            spacing={1}
                            sx={{
                              width: { xs: 12, md: 16, lg: 22 },
                              height: { xs: 12, md: 16, lg: 22 },
                              ml: "2px",
                              cursor: "pointer",
                            }}
                          >
                            <img
                              src={infoImage}
                              alt=""
                              onClick={(e) => {
                                navigate(APP_ROUTES.ROUTE_EMAILTEMPLATE, {
                                  state: {
                                    id: res?.id,
                                    action: "info",
                                  },
                                });
                              }}
                            />
                          </Stack>
                        </Stack>
                        {res?.created_by === loginData?.id ? (<Stack>
                            <Stack
                              spacing={1}
                              sx={{
                                width: { xs: 11, md: 15 },
                                height: { xs: 11, md: 15 },
                                mt: "4px",
                                cursor: "pointer",
                              }}
                            >
                              <img
                                src={deleteIcon}
                                alt=""
                                onClick={(e) => {
                                  deleteEmail(e, res.id);
                                }}
                              />
                            </Stack>
                          </Stack>) : ("")}
                        </Stack>
                      </Stack>
                    </Box>
                  </Grid>
                {/* ) : ( */}
                  {/* ""
                // )} */}
              </Stack>
            </Box>
          );
        })
      ) : (
        <Stack
          direction="row"
          spacing={{ xs: "50%", md: 1 }}
          sx={{
            justifyContent: {
              xs: "space-evenly",
              md: "center",
            },
            paddingLeft: { xs: "10%", md: "0%" },
            paddingTop: { xs: "2%", md: "0%" },
          }}
        >
          No Record Found
        </Stack>
      )}
      {deleteModal ? (
        <SingleDelete
          closeModal={closemodal}
          singleDeleteModal={() => EmailDelete()}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default EmailList;
